import React from 'react';

import { Box, Skeleton, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { AvatarSize } from '../../../../shared/constants';
import { useStyles } from './UserProfileSkeleton.styles';

interface IUserProfileSkeletonProps {
  avatarSize?: AvatarSize;
}

export default function UserProfileSkeleton({
  avatarSize = AvatarSize.l,
}: IUserProfileSkeletonProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { classes } = useStyles(theme);

  return (
    <>
      <div className={classes.container}>
        <Skeleton
          variant="circular"
          width={avatarSize}
          height={avatarSize}
          animation="wave"
        />
        <div className={classes.content}>
          <Skeleton variant="text" width="45%" height={36} animation="wave" />
          <Skeleton variant="text" width="70%" height={28} animation="wave" />
        </div>
      </div>
      <Box className={classes.detailsWrapper}>
        <Box className={classes.postsWrapper}>
          <Box className={classes.cardContainer}>
            <Box className={classes.newPostHeader}>
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                animation="wave"
              />
              <Box className={classes.newPostHeaderText}>
                <Skeleton
                  variant="text"
                  width="42%"
                  height={24}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width="30%"
                  height={20}
                  animation="wave"
                />
              </Box>
            </Box>
            <Skeleton
              variant="rounded"
              className={classes.newPostInput}
              animation="wave"
            />
            <Box className={classes.newPostActions}>
              <Skeleton
                variant="rounded"
                width={84}
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="rounded"
                width={96}
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="rounded"
                width={72}
                height={24}
                animation="wave"
              />
            </Box>
          </Box>
          {[1, 2].map((item) => (
            <Box key={item} className={classes.cardContainer}>
              <Box className={classes.postHeader}>
                <Skeleton
                  variant="circular"
                  width={36}
                  height={36}
                  animation="wave"
                />
                <Box className={classes.postHeaderText}>
                  <Skeleton
                    variant="text"
                    width="55%"
                    height={22}
                    animation="wave"
                  />
                  <Skeleton
                    variant="text"
                    width="35%"
                    height={18}
                    animation="wave"
                  />
                </Box>
              </Box>
              <Skeleton
                variant="text"
                width="94%"
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="88%"
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="rounded"
                className={classes.postMediaPlaceholder}
                animation="wave"
              />
              <Box className={classes.postFooter}>
                <Skeleton
                  variant="text"
                  width={52}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={64}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={48}
                  height={20}
                  animation="wave"
                />
              </Box>
            </Box>
          ))}
        </Box>
        <Box className={classes.relationsWrapper}>
          {[1, 2, 3].map((item) => (
            <Box key={item} className={classes.cardContainer}>
              <Skeleton
                variant="text"
                width="48%"
                height={28}
                animation="wave"
              />
              <Box className={classes.relationList}>
                {[1, 2, 3].map((row) => (
                  <Box
                    key={`${item}-${row}`}
                    className={classes.relationListRow}>
                    <Skeleton
                      variant="circular"
                      width={32}
                      height={32}
                      animation="wave"
                    />
                    {!isMobile && (
                      <Skeleton
                        variant="text"
                        width="62%"
                        height={22}
                        animation="wave"
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}
